import { getFeaturedEvent, getAppSettings } from "../../api/api";
import { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import "./featuredevent.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { handleError } from "../../helpers/handleError";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import { useMediaQuery } from "react-responsive";
const FeaturedEvent = ({ bgColor }) => {
  const navigate = useNavigate();
  const [featuredEvent, setFeaturedEvent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [appSettings, setAppSettings] = useState({});
  const swiperRef = useRef(null);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const fetchAppSettings = async () => {
    try {
      setLoading(true);
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFeaturedEvent = async () => {
    try {
      const res = await getFeaturedEvent();
      setFeaturedEvent(res.data.info);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFirstClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(swiperRef.current.activeIndex);
    }
  };

  const handleLastClick = () => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(swiperRef.current.activeIndex);
    }
  };

  useEffect(() => {
    fetchFeaturedEvent();
    fetchAppSettings();
  }, []);
  if (loading) return <SpinLoading />;
  return (
    <>
      <Row style={{ padding: "0px", margin: "0px", backgroundColor: bgColor }}>
        <Col sm={12} md={12} lg={12} xl={12} className="featuredevent1">
          <span>EVENTOS DESTACADOS</span>
        </Col>
        <Col sm={12} md={12} lg={12} xl={12} className="featuredevent2">
          <span>¡No te pierdas los acontecimientos más emocionantes cerca de ti!</span>
        </Col>
      </Row>
      <Swiper
        slidesPerView={3.4}
        spaceBetween={20}
        pagination={{
          el: ".pagination-bullets-featuredevent",
          clickable: true,
        }}
        navigation={{
          prevEl: ".arrow-featuredevent.first",
          nextEl: ".arrow-featuredevent.last",
        }}
        breakpoints={{
          1400: {
            slidesPerView: 3.4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 1.1,
            spaceBetween: 10,
          },
          0: {
            slidesPerView: 1.1,
            spaceBetween: 5,
          },
        }}
        modules={[Pagination, Navigation]}
        className="mySwiperfeaturedevent paddingleft150"
        onSwiper={(swiper) => {
          swiperRef.current = swiper; // Store swiper instance in useRef
        }}
        style={{ backgroundColor: bgColor }}
      >
        {featuredEvent.map((item, index) => (
          <SwiperSlide key={index} className="featuredevent3">
            <Card className="featuredevent4">
              <div className="featuredeventimagecontainer">
                <Card.Img
                  variant="top"
                  className="featuredeventimage"
                  src={isMobile ? (item.mobileimage || item.mobileImage || item.image) : item.image}
                />
                <div className="featuredeventimageoverlay">
                  {item.isFree ? "" : `${appSettings.currency}${item.price}`}
                </div>
                <div className="featuredeventimageoverlay2">{dayjs(String(item.startDate || '').slice(0,10)).format("DD MMM, YYYY")}</div>
              </div>

              <Card.Body>
                <Card.Title className="featuredeventcardtitle">{item.name}</Card.Title>
                <Card.Text className="featuredeventcardtext">
                  <div>
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 0C3.85813 0 0.5 3.35813 0.5 7.5C0.5 9.13094 1.03469 10.6275 1.92344 11.8531C1.93938 11.8825 1.94187 11.9153 1.96 11.9434L6.96 19.4434C7.19188 19.7913 7.5825 20 8 20C8.4175 20 8.80812 19.7913 9.04 19.4434L14.04 11.9434C14.0584 11.9153 14.0606 11.8825 14.0766 11.8531C14.9653 10.6275 15.5 9.13094 15.5 7.5C15.5 3.35813 12.1419 0 8 0ZM8 10C6.61937 10 5.5 8.88062 5.5 7.5C5.5 6.11937 6.61937 5 8 5C9.38062 5 10.5 6.11937 10.5 7.5C10.5 8.88062 9.38062 10 8 10Z"
                        fill="#bac819"
                      />
                    </svg>
                  </div>
                  <div className="featuredeventlocation">{item.fulladdress}</div>
                </Card.Text>
                <div className="featuredeventcardbutton">
                  <Button
                    className="featuredeventbutton"
                    onClick={() => navigate(`/event/${item._id}`, { state: { name: item.name } })}
                  >
                    <span class="featuredeventbuttontransition"></span>
                    <span class="featuredeventbuttonlabel">
                      {item.endDate > dayjs().format("YYYY-MM-DD")
                        ? item.maxbooking > item.totalbooking
                          ? "Obtener entrada"
                          : "Sin entradas"
                        : "Sin entradas"}
                    </span>
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="custom-pagination-featuredevent" style={{ backgroundColor: bgColor }}>
        <button className="arrow-featuredevent first" onClick={handleFirstClick} style={{ marginRight: "5px" }}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.219639 6.53021C-0.0732538 6.23732 -0.0732538 5.76244 0.219639 5.46955L4.71964 0.969548C5.01253 0.676655 5.48741 0.676655 5.7803 0.969548C6.07319 1.26244 6.07319 1.73732 5.7803 2.03021L2.56063 5.24988L11.25 5.24988C11.6642 5.24988 12 5.58566 12 5.99988C12 6.41409 11.6642 6.74988 11.25 6.74988L2.56063 6.74988L5.7803 9.96955C6.07319 10.2624 6.07319 10.7373 5.7803 11.0302C5.48741 11.3231 5.01253 11.3231 4.71964 11.0302L0.219639 6.53021Z"
              fill="#8F99A2"
            />
          </svg>
        </button>

        <div className="pagination-bullets-featuredevent"></div>

        <button className="arrow-featuredevent last" onClick={handleLastClick} style={{ marginLeft: "5px" }}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L7.28033 11.0303C6.98744 11.3232 6.51256 11.3232 6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96967L9.43934 6.75L0.75 6.75C0.335787 6.75 0 6.41421 0 6C0 5.58579 0.335787 5.25 0.75 5.25L9.43934 5.25L6.21967 2.03033C5.92678 1.73744 5.92678 1.26256 6.21967 0.96967C6.51256 0.676777 6.98744 0.676777 7.28033 0.96967L11.7803 5.46967Z"
              fill="#8F99A2"
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default FeaturedEvent;
